"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMediaEngineDispatch = void 0;
const native_rtc_1 = require("@iris/native-rtc");
const CallApiBufferExtensions_1 = require("../extensions/CallApiBufferExtensions");
const IAgoraMediaEngineImpl_1 = require("../impl/IAgoraMediaEngineImpl");
const AgoraConsole_1 = require("../util/AgoraConsole");
class IMediaEngineDispatch {
    constructor(engine) {
        this._impl = new IAgoraMediaEngineImpl_1.IMediaEngineImpl(engine);
        this._engine = engine;
    }
    // @ts-ignore
    registerAudioFrameObserver_d873a64(apiParam) {
        let eventHandler = apiParam.buffer[0]; //obj.eventHandler;
        if (eventHandler === undefined) {
            AgoraConsole_1.AgoraConsole.error('eventHandler is undefined');
            throw 'eventHandler is undefined';
        }
        return this._impl.registerAudioFrameObserver_d873a64(eventHandler);
    }
    // @ts-ignore
    registerVideoFrameObserver_2cc0ef1(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_registerVideoFrameObserver_2cc0ef1 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerVideoEncodedFrameObserver_d45d579(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_registerVideoEncodedFrameObserver_d45d579 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerFaceInfoObserver_0303ed6(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_registerFaceInfoObserver_0303ed6 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    pushAudioFrame_c71f4ab(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_pushAudioFrame_c71f4ab not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    pullAudioFrame_2c74a9c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_pullAudioFrame_2c74a9c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setExternalVideoSource_fff99b6(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let enabled = obj.enabled;
        if (enabled === undefined) {
            AgoraConsole_1.AgoraConsole.error('enabled is undefined');
            throw 'enabled is undefined';
        }
        let useTexture = obj.useTexture;
        if (useTexture === undefined) {
            AgoraConsole_1.AgoraConsole.error('useTexture is undefined');
            throw 'useTexture is undefined';
        }
        let sourceType = obj.sourceType;
        if (sourceType === undefined) {
            AgoraConsole_1.AgoraConsole.error('sourceType is undefined');
            throw 'sourceType is undefined';
        }
        let encodedVideoOption = obj.encodedVideoOption;
        if (encodedVideoOption === undefined) {
            AgoraConsole_1.AgoraConsole.error('encodedVideoOption is undefined');
            throw 'encodedVideoOption is undefined';
        }
        return this._impl.setExternalVideoSource_fff99b6(enabled, useTexture, sourceType, encodedVideoOption);
    }
    // @ts-ignore
    setExternalRemoteEglContext_f337cbf(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_setExternalRemoteEglContext_f337cbf not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setExternalAudioSource_e6538be(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_setExternalAudioSource_e6538be not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    createCustomAudioTrack_5a0bf1a(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_createCustomAudioTrack_5a0bf1a not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    destroyCustomAudioTrack_6178b5d(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_destroyCustomAudioTrack_6178b5d not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setExternalAudioSink_d275ce0(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_setExternalAudioSink_d275ce0 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableCustomAudioLocalPlayback_5f38e8a(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_enableCustomAudioLocalPlayback_5f38e8a not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    pushVideoFrame_4e544e2(apiParam) {
        let obj = JSON.parse(apiParam.data);
        obj = (0, CallApiBufferExtensions_1.callApiBufferExtension)(apiParam.event, obj, apiParam.buffer);
        let frame = obj.frame;
        if (frame === undefined) {
            AgoraConsole_1.AgoraConsole.error('frame is undefined');
            throw 'frame is undefined';
        }
        let videoTrackId = obj.videoTrackId;
        if (videoTrackId === undefined) {
            AgoraConsole_1.AgoraConsole.error('videoTrackId is undefined');
            throw 'videoTrackId is undefined';
        }
        return this._impl.pushVideoFrame_4e544e2(frame, videoTrackId);
    }
    // @ts-ignore
    pushEncodedVideoImage_e71452b(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_pushEncodedVideoImage_e71452b not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    addVideoFrameRenderer_2cc0ef1(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_addVideoFrameRenderer_2cc0ef1 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    removeVideoFrameRenderer_2cc0ef1(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_removeVideoFrameRenderer_2cc0ef1 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    release() {
        AgoraConsole_1.AgoraConsole.warn('MediaEngine_release not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IMediaEngineDispatch = IMediaEngineDispatch;
